import { createTheme } from '@mui/material/styles';

// Define color palettes for light and dark modes with a more vibrant theme
const lightPalette = {
  mode: 'light',
  primary: {
    main: '#673ab7', // Deep Purple
    light: '#9575cd',
    dark: '#512da8',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#ff5722', // Deep Orange
    light: '#ff8a65',
    dark: '#e64a19',
    contrastText: '#ffffff',
  },
  background: {
    default: '#f8fafc', // Slate 50
    paper: '#ffffff',
  },
  text: {
    primary: '#0f172a', // Slate 900
    secondary: '#475569', // Slate 600
  },
  divider: 'rgba(15, 23, 42, 0.08)',
};

const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#9c27b0', // Vibrant Purple for Dark Mode
    light: '#ba68c8',
    dark: '#7b1fa2',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#ff9800', // Vibrant Orange for Dark Mode
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#ffffff',
  },
  background: {
    default: '#020617', // Deep Slate 950
    paper: '#0f172a',   // Slate 900
  },
  text: {
    primary: '#f8fafc', // Slate 50
    secondary: '#94a3b8', // Slate 400
  },
  divider: 'rgba(248, 250, 252, 0.08)',
};

export const getAppTheme = (mode) => createTheme({
  palette: mode === 'light' ? lightPalette : darkPalette,
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
        },
        containedPrimary: {
          boxShadow: '0 4px 12px rgba(79, 70, 229, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(79, 70, 229, 0.35)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        rounded: {
          borderRadius: 16,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: mode === 'light'
            ? '0 4px 20px rgba(0, 0, 0, 0.05)'
            : '0 4px 20px rgba(0, 0, 0, 0.4)',
        },
      },
    },
  },
});

const theme = getAppTheme('light');
export default theme;
